export default __webpack_public_path__ + "static/media/csharp.c7c6fad1.svg";